import styled from "styled-components";

export const SelectIconWrapper = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #F3F5F5;
  margin-right: 8px;
  cursor: pointer;
`;